// extracted by mini-css-extract-plugin
export default {"link_wrapper":"l4oUQddBcXAy1Pmra36J","link":"JxKxFxcCaFNmDEBfMrMl","download_icon":"IBOY9fd32u4fFa8RnfBw"};